import { Injectable } from '@angular/core';
import { Observable, forkJoin, from, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HashService {
  constructor() {}

  digest(input: any, algorithm: string = 'SHA-256'): Observable<string | undefined> {
    if (!input) return of(undefined);

    const message: string = JSON.stringify(input);
    const msgUint8: Uint8Array = new TextEncoder().encode(message);
    return from(crypto.subtle.digest(algorithm, msgUint8)).pipe(
      map((hashBuffer: ArrayBuffer) => {
        const hashArray: number[] = Array.from(new Uint8Array(hashBuffer));
        const hashHex: string = hashArray
          .map((b: number) => b.toString(16).padStart(2, '0'))
          .join('');
        return hashHex;
      })
    );
  }

  digestArray<T>(inputs: T[], algorithm: string = 'SHA-256'): Observable<(string | undefined)[]> {
    return forkJoin(inputs.map((input: T) => this.digest(input, algorithm)));
  }

  equals(input: any, hash: string, algorithm: string = 'SHA-256'): Observable<boolean> {
    return this.digest(input, algorithm).pipe(
      map((digest: string | undefined) => digest !== undefined && digest === hash)
    );
  }

  filterArrayOutByHashes<T>(
    inputs: T[],
    hashes: string[],
    algorithm: string = 'SHA-256'
  ): Observable<T[]> {
    const hashes_set: Set<string> = new Set(hashes);

    return this.digestArray(inputs, algorithm).pipe(
      map((input_hashes: (string | undefined)[]) => {
        const filtered_inputs: T[] = [];
        input_hashes.forEach((input_hash: string | undefined, index: number) => {
          if (input_hash && !hashes_set.has(input_hash)) filtered_inputs.push(inputs[index]);
        });
        return filtered_inputs;
      })
    );
  }
}
